import { useEffect } from "react";

function bypassSummary(){
  const overlay=document.querySelector<HTMLElement>(".qualification-record-overlay");
  if(!overlay)return;

  const eyebrow=[...overlay.querySelectorAll<HTMLElement>(".eyebrow")]
    .find(x=>x.textContent?.trim()==="CONTROLLED WELDER QUALIFICATION");
  if(!eyebrow)return;

  const panel=overlay.querySelector<HTMLElement>(".qualification-record-panel");
  if(panel)panel.style.visibility="hidden";

  const edit=[...overlay.querySelectorAll<HTMLButtonElement>("button")]
    .find(x=>x.textContent?.trim()==="Edit record");
  if(!edit)return;

  edit.click();

  requestAnimationFrame(()=>{
    const form=overlay.querySelector("form");
    if(form&&panel)panel.style.visibility="";
  });
}

export default function QualificationSummaryBypass(){
  useEffect(()=>{
    const observer=new MutationObserver(()=>bypassSummary());
    observer.observe(document.body,{childList:true,subtree:true});
    const timer=window.setInterval(bypassSummary,50);
    bypassSummary();
    return()=>{
      observer.disconnect();
      window.clearInterval(timer);
    };
  },[]);
  return null;
}
